import { FC } from "react";

export const Sort: FC = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 10.833L2 10.833C1.72667 10.833 1.5 11.0597 1.5 11.333C1.5 11.6063 1.72667 11.833 2 11.833L14 11.833C14.2733 11.833 14.5 11.6063 14.5 11.333C14.5 11.0597 14.2733 10.833 14 10.833Z"
      fill="#007BFB"
    />
    <path
      d="M12 7.5L4 7.5C3.72667 7.5 3.5 7.72667 3.5 8C3.5 8.27333 3.72667 8.5 4 8.5L12 8.5C12.2733 8.5 12.5 8.27333 12.5 8C12.5 7.72667 12.2733 7.5 12 7.5Z"
      fill="#007BFB"
    />
    <path
      d="M9.33268 4.16699L6.66602 4.16699C6.39268 4.16699 6.16602 4.39366 6.16602 4.66699C6.16602 4.94033 6.39268 5.16699 6.66602 5.16699L9.33268 5.16699C9.60602 5.16699 9.83268 4.94033 9.83268 4.66699C9.83268 4.39366 9.60602 4.16699 9.33268 4.16699Z"
      fill="#007BFB"
    />
  </svg>
);
